import {Component, Input, OnInit} from '@angular/core';
import {NgxSpinnerComponent, NgxSpinnerService} from 'ngx-spinner';
import {SpinnerService} from './spinner.service';
import {AsyncPipe} from '@angular/common';

@Component({
	selector: 'spinner',
	imports: [NgxSpinnerComponent, AsyncPipe],
	template: `
    <ngx-spinner
        [zIndex]="spinnerService.zIndex$|async"
        [fullScreen]="spinnerService.fullScreen$|async"
        [bdColor]="bgColor"
        [size]="size"
        [color]="color"
        [type]="type">
      @if (spinnerText?.length) {
        <h2 style="margin-top: 80px; color: white; text-align: center; font-weight: bold;">
          {{ spinnerText }}
        </h2>
      }
    </ngx-spinner>
	`
})
export class SpinnerComponent implements OnInit {

	@Input() show: boolean;

	spinnerText: string;
	bgColor: string;
	size: 'default' | 'small' | 'medium' | 'large';
	color: string;
	type: string;

	constructor(private spinner: NgxSpinnerService,
	            public spinnerService: SpinnerService) {
		this.spinnerText = this.spinnerService.config.spinnerText;
		this.bgColor = this.spinnerService.config.bgColor;
		this.size = this.spinnerService.config.size;
		this.color = this.spinnerService.config.color;
		this.type = this.spinnerService.config.type;
	}

	ngOnInit() {
		this.spinnerService.spinnerText$.subscribe(textValue => this.spinnerText = textValue);
		this.spinnerService.getSpinnerStatus().subscribe((show: boolean) => {
			if (show) {
				this.spinner.show();
			} else {
				this.spinner.hide();
			}
		});
	}

}
